import { render, staticRenderFns } from "./bindWeixin.vue?vue&type=template&id=c33eec5c&"
import script from "./bindWeixin.vue?vue&type=script&lang=js&"
export * from "./bindWeixin.vue?vue&type=script&lang=js&"
import style0 from "./bindWeixin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports